/**
 * Avatar - 사용자 프로필 아바타 컴포넌트
 *
 * 이미지가 있으면 표시하고, 없거나 로드 실패 시 이름 이니셜을 배경색과 함께 표시.
 * @param name - 사용자 이름 (이니셜 및 배경색 생성에 사용)
 * @param online - 온라인 상태 표시 도트 (undefined이면 숨김)
 */
'use client';

import React from 'react';
import styles from './Avatar.module.css';

export interface AvatarProps {
  src?: string;
  name: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  online?: boolean;
  group?: boolean;
}

const AVATAR_COLORS = [
  '#6566F1',
  '#F43F5E',
  '#F59E0B',
  '#22C55E',
  '#A5B4FC',
  '#FB7185',
  '#4ECDC4',
  '#818CF8',
];

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

function getColorFromName(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export default function Avatar({ src, name, size = 'md', online, group = false }: AvatarProps) {
  const [imgError, setImgError] = React.useState(false);
  const initials = getInitials(name);
  const bgColor = getColorFromName(name);
  const showImage = src && !imgError;

  return (
    <div className={`${styles.avatar} ${styles[size]} ${group ? styles.group : ''}`} title={name}>
      {showImage ? (
        <img src={src} alt={name} className={styles.image} onError={() => setImgError(true)} />
      ) : (
        <span className={styles.initials} style={{ backgroundColor: bgColor }}>
          {initials}
        </span>
      )}
      {online !== undefined && (
        <span className={`${styles.statusDot} ${online ? styles.online : styles.offline}`} />
      )}
    </div>
  );
}
